
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/the-software-engineers-guidebook",
      function () {
        return require("private-next-pages/books/the-software-engineers-guidebook.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/the-software-engineers-guidebook"])
      });
    }
  